import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Landing Page
      lp: {
        nav: {
          features: 'Features',
          pricing: 'Pricing',
          contact: 'Contact',
          tryDemo: 'Try Demo',
          login: 'Login'
        },
        hero: {
          badge: 'Built for Contractors',
          title: 'Run Your Contracting Business',
          titleHighlight: 'From Anywhere',
          subtitle: 'Professional estimates, invoicing, and job management. All in one simple app built for contractors who work in the field.',
          cta: 'Start Free Trial',
          demo: 'Watch Demo'
        },
        features: {
          title: 'Everything You Need to Run Your Business',
          subtitle: 'From first estimate to final payment, we\'ve got you covered.',
          estimates: {
            title: 'Professional Estimates',
            desc: 'Create beautiful, branded estimates in minutes. Send them instantly via email or text.'
          },
          scheduling: {
            title: 'Job Scheduling',
            desc: 'Keep track of all your jobs with our easy calendar. Never double-book again.'
          },
          invoicing: {
            title: 'Easy Invoicing',
            desc: 'Turn approved estimates into invoices with one click. Get paid faster.'
          },
          payments: {
            title: 'Accept Payments',
            desc: 'Accept credit cards, checks, or cash. Track everything in one place.'
          },
          offline: {
            title: 'Works Offline',
            desc: 'No internet? No problem. Works even without cell service.'
          },
          mobile: {
            title: 'Mobile First',
            desc: 'Designed for phones and tablets. Use it right on the job site.'
          }
        },
        pricing: {
          title: 'Simple, Transparent Pricing',
          subtitle: 'No hidden fees. Cancel anytime.',
          basic: {
            name: 'Portal Basic',
            price: '79',
            desc: 'Perfect for solo contractors',
            features: ['1 user', 'Up to 50 clients', 'Unlimited estimates', 'Job scheduling', 'Invoicing & payments', 'Calendar view', 'Offline mode (PWA)']
          },
          pro: {
            name: 'Portal Pro',
            price: '149',
            desc: 'For growing businesses',
            popular: 'MOST POPULAR',
            features: ['Up to 5 users', 'Unlimited clients', 'Everything in Basic', 'Crew management', 'Automation workflows', 'Advanced reporting', 'Priority support', 'Custom branding']
          },
          cta: 'Get Started'
        },
        mobile: {
          badge: 'Built for the Field',
          title: 'Your Office in Your Pocket',
          subtitle: 'ContractorOS is designed mobile-first for contractors who work on job sites, not behind desks. Create estimates, schedule jobs, and send invoices right from your phone or tablet.',
          features: ['Works offline in the field', 'Install as an app on any device', 'Large buttons built for work gloves'],
          qr: {
            title: 'Scan to Try on Mobile',
            subtitle: 'Point your camera at the code',
            cta: 'Try the free demo instantly'
          }
        },
        cta: {
          title: 'Ready to Simplify Your Business?',
          subtitle: 'Join hundreds of contractors who trust ContractorOS',
          button: 'Start Your Free Trial'
        },
        footer: {
          desc: 'The all-in-one client portal for contractors. Professional estimates, invoicing, job scheduling, and more.',
          product: 'Product',
          company: 'Company',
          contact: 'Contact',
          about: 'About',
          careers: 'Careers',
          privacy: 'Privacy',
          terms: 'Terms',
          copyright: 'ContractorOS by BirdenMedia. All rights reserved.'
        }
      },
      // Login Page
      login: {
        title: 'ContractorOS',
        subtitle: 'by BirdenMedia',
        signIn: 'Sign in to your portal',
        email: 'Email',
        emailAddress: 'Email Address',
        password: 'Password',
        forgotPassword: 'Forgot password?',
        signInBtn: 'Sign In',
        signingIn: 'Signing in...',
        demoAccess: 'Quick Demo Access',
        demoEmail: 'Enter demo@demo.com for instant access',
        poweredBy: 'Powered by BirdenMedia',
        or: 'or',
        emailMeLink: 'Email me a login link',
        checkEmail: 'Check Your Email',
        sentLinkTo: 'We sent a login link to',
        useDifferentEmail: 'Use a different email',
        resetPassword: 'Reset Your Password',
        resetDesc: "Enter your email address and we'll send you a link to reset your password.",
        sendResetLink: 'Send Reset Link',
        sending: 'Sending...',
        cancel: 'Cancel',
        backToLogin: 'Back to Login',
        ifAccountExists: 'If an account exists for',
        willReceiveLink: ', you will receive a password reset link shortly.'
      },
      // Language
      language: {
        en: 'English',
        es: 'Español'
      }
    }
  },
  es: {
    translation: {
      // Landing Page
      lp: {
        nav: {
          features: 'Funciones',
          pricing: 'Precios',
          contact: 'Contacto',
          tryDemo: 'Probar Demo',
          login: 'Iniciar Sesión'
        },
        hero: {
          badge: 'Hecho para Contratistas',
          title: 'Administra Tu Negocio de Contratista',
          titleHighlight: 'Desde Cualquier Lugar',
          subtitle: 'Presupuestos profesionales, facturación y gestión de trabajos. Todo en una aplicación simple hecha para contratistas que trabajan en el campo.',
          cta: 'Comenzar Prueba Gratis',
          demo: 'Ver Demo'
        },
        features: {
          title: 'Todo lo que Necesitas para Tu Negocio',
          subtitle: 'Desde el primer presupuesto hasta el pago final, te tenemos cubierto.',
          estimates: {
            title: 'Presupuestos Profesionales',
            desc: 'Crea presupuestos hermosos con tu marca en minutos. Envíalos al instante por email o mensaje.'
          },
          scheduling: {
            title: 'Programación de Trabajos',
            desc: 'Mantén un registro de todos tus trabajos con nuestro calendario fácil. Nunca más dobles reservas.'
          },
          invoicing: {
            title: 'Facturación Fácil',
            desc: 'Convierte presupuestos aprobados en facturas con un clic. Cobra más rápido.'
          },
          payments: {
            title: 'Acepta Pagos',
            desc: 'Acepta tarjetas de crédito, cheques o efectivo. Rastrea todo en un solo lugar.'
          },
          offline: {
            title: 'Funciona Sin Internet',
            desc: '¿Sin internet? No hay problema. Funciona incluso sin servicio celular.'
          },
          mobile: {
            title: 'Diseñado para Móvil',
            desc: 'Diseñado para teléfonos y tabletas. Úsalo directamente en el sitio de trabajo.'
          }
        },
        pricing: {
          title: 'Precios Simples y Transparentes',
          subtitle: 'Sin cargos ocultos. Cancela cuando quieras.',
          basic: {
            name: 'Portal Básico',
            price: '79',
            desc: 'Perfecto para contratistas independientes',
            features: ['1 usuario', 'Hasta 50 clientes', 'Presupuestos ilimitados', 'Programación de trabajos', 'Facturación y pagos', 'Vista de calendario', 'Modo sin conexión (PWA)']
          },
          pro: {
            name: 'Portal Pro',
            price: '149',
            desc: 'Para negocios en crecimiento',
            popular: 'MÁS POPULAR',
            features: ['Hasta 5 usuarios', 'Clientes ilimitados', 'Todo en Básico', 'Gestión de equipo', 'Automatizaciones', 'Reportes avanzados', 'Soporte prioritario', 'Marca personalizada']
          },
          cta: 'Comenzar'
        },
        mobile: {
          badge: 'Hecho para el Campo',
          title: 'Tu Oficina en Tu Bolsillo',
          subtitle: 'ContractorOS está diseñado primero para móvil, para contratistas que trabajan en sitios de trabajo, no detrás de escritorios. Crea presupuestos, programa trabajos y envía facturas desde tu teléfono o tableta.',
          features: ['Funciona sin conexión en el campo', 'Instálalo como app en cualquier dispositivo', 'Botones grandes para guantes de trabajo'],
          qr: {
            title: 'Escanea para Probar en Móvil',
            subtitle: 'Apunta tu cámara al código',
            cta: 'Prueba el demo gratis al instante'
          }
        },
        cta: {
          title: '¿Listo para Simplificar Tu Negocio?',
          subtitle: 'Únete a cientos de contratistas que confían en ContractorOS',
          button: 'Comienza Tu Prueba Gratis'
        },
        footer: {
          desc: 'El portal todo-en-uno para contratistas. Presupuestos profesionales, facturación, programación de trabajos y más.',
          product: 'Producto',
          company: 'Empresa',
          contact: 'Contacto',
          about: 'Acerca de',
          careers: 'Empleos',
          privacy: 'Privacidad',
          terms: 'Términos',
          copyright: 'ContractorOS por BirdenMedia. Todos los derechos reservados.'
        }
      },
      // Login Page
      login: {
        title: 'ContractorOS',
        subtitle: 'por BirdenMedia',
        signIn: 'Inicia sesión en tu portal',
        email: 'Correo electrónico',
        emailAddress: 'Correo Electrónico',
        password: 'Contraseña',
        forgotPassword: '¿Olvidaste tu contraseña?',
        signInBtn: 'Iniciar Sesión',
        signingIn: 'Iniciando sesión...',
        demoAccess: 'Acceso Rápido al Demo',
        demoEmail: 'Ingresa demo@demo.com para acceso instantáneo',
        poweredBy: 'Desarrollado por BirdenMedia',
        or: 'o',
        emailMeLink: 'Enviarme un enlace de inicio de sesión',
        checkEmail: 'Revisa Tu Correo',
        sentLinkTo: 'Enviamos un enlace de inicio de sesión a',
        useDifferentEmail: 'Usar otro correo',
        resetPassword: 'Restablecer Tu Contraseña',
        resetDesc: 'Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.',
        sendResetLink: 'Enviar Enlace',
        sending: 'Enviando...',
        cancel: 'Cancelar',
        backToLogin: 'Volver al Inicio de Sesión',
        ifAccountExists: 'Si existe una cuenta para',
        willReceiveLink: ', recibirás un enlace de restablecimiento de contraseña en breve.'
      },
      // Language
      language: {
        en: 'English',
        es: 'Español'
      }
    }
  }
};

// Get initial language from multiple possible sources
const getInitialLanguage = () => {
  return localStorage.getItem('language') || 
         localStorage.getItem('user_language') || 
         'en';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
